import { BlockingInterfacesContext } from './context';
import { BlockingInterfacesContextValue, BlockingInterfacesProviderProps } from './types';
import { useCallback, useMemo, useRef, useState } from 'react';

const BlockingInterfacesProvider = (props: BlockingInterfacesProviderProps) => {
  const {
    children
  } = props;
  const blockingInterfaceCountsRef = useRef<Map<string, number>>(new Map());
  const [blockingInterfaceIds, setBlockingInterfaceIds] = useState<string[]>([]);

  const registerBlockingInterface = useCallback((blockingInterfaceId: string): void => {
    const currentCount = blockingInterfaceCountsRef.current.get(blockingInterfaceId) ?? 0;

    blockingInterfaceCountsRef.current.set(blockingInterfaceId, currentCount + 1);

    if (currentCount === 0) {
      setBlockingInterfaceIds((currentIds) => [...currentIds, blockingInterfaceId].sort());
    }
  }, []);

  const unregisterBlockingInterface = useCallback((blockingInterfaceId: string): void => {
    const currentCount = blockingInterfaceCountsRef.current.get(blockingInterfaceId) ?? 0;

    if (currentCount <= 1) {
      blockingInterfaceCountsRef.current.delete(blockingInterfaceId);
      setBlockingInterfaceIds((currentIds) => currentIds.filter((currentId) => currentId !== blockingInterfaceId));
      return;
    }

    blockingInterfaceCountsRef.current.set(blockingInterfaceId, currentCount - 1);
  }, []);

  const value = useMemo<BlockingInterfacesContextValue>(() => ({
    isBlocked: blockingInterfaceIds.length > 0,
    registerBlockingInterface,
    unregisterBlockingInterface
  }), [blockingInterfaceIds, registerBlockingInterface, unregisterBlockingInterface]);

  return (
    <BlockingInterfacesContext.Provider value={value}>
      {children}
    </BlockingInterfacesContext.Provider>
  );
};

export default BlockingInterfacesProvider;